import { ROLEPLAY_END_MESSAGE, ROLEPLAY_START_MESSAGE, roleplayPhaseMinutes, type DurationMinutes } from '../shared/contract';
import type { TranscriptEntry, TranscriptLine } from './types';

/** Role play has three phases: 1 intro with Tania, 2 screening call (Tania as candidate), 3 Q&A with Tania. */
export type RolePlayPhase = 1 | 2 | 3;

export const START_ROLEPLAY_MESSAGE = ROLEPLAY_START_MESSAGE;
export const END_ROLEPLAY_MESSAGE = ROLEPLAY_END_MESSAGE;

export const PHASE_CHIP: Record<RolePlayPhase, string> = {
  1: '1 · Intro with Tania',
  2: '2 · Screening call',
  3: '3 · Q&A with Tania',
};

export const PHASE_SHORT: Record<RolePlayPhase, string> = {
  1: '1 · Intro',
  2: '2 · Screening',
  3: '3 · Q&A',
};

export const PHASE_TAG: Record<RolePlayPhase, string> = {
  1: 'Intro',
  2: 'Screening call',
  3: 'Q&A',
};

/** Minutes planned for each phase (60 min = 5 / 40 / 15), from the shared contract. */
export function phaseMinutes(duration: DurationMinutes): Record<RolePlayPhase, number> {
  const plan = roleplayPhaseMinutes(duration);
  return { 1: plan.opening, 2: plan.screening, 3: plan.qa };
}

const PHASE_NAME = { 1: 'opening', 2: 'screening', 3: 'qa' } as const;

/** Tags each line with the role-play phase it was spoken in so the feedback can score the screening part. */
export function tagTranscriptLines(
  entries: TranscriptEntry[],
  phaseById: Record<string, RolePlayPhase>,
): TranscriptLine[] {
  return entries.map((entry) => ({
    role: entry.role === 'interviewer' ? 'ai' : 'user',
    text: entry.text,
    phase: PHASE_NAME[phaseById[entry.id] ?? 1],
  }));
}
